import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgWaveform = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M10.0381 3C10.5372 3.00011 10.9334 3.39587 10.9336 3.89062V21.1094C10.9334 21.6041 10.5372 21.996 10.0381 21.9961C9.5475 21.9961 9.16425 21.6042 9.16406 21.1094V3.89062C9.16427 3.3958 9.54751 3 10.0381 3ZM16.2109 4.87695C16.7057 4.87715 17.0976 5.27706 17.0977 5.76758V19.2324C17.0975 19.7229 16.7057 20.1141 16.2109 20.1143C15.7116 20.1143 15.3282 19.723 15.3281 19.2324V5.76758C15.3282 5.27694 15.7116 4.87695 16.2109 4.87695ZM6.95605 6.125C7.45528 6.12511 7.85156 6.52556 7.85156 7.02051V17.9756C7.85139 18.4704 7.45517 18.8622 6.95605 18.8623C6.46976 18.8623 6.0822 18.4704 6.08203 17.9756V7.02051C6.08203 6.52549 6.46965 6.125 6.95605 6.125ZM13.124 7.36035C13.6232 7.36035 14.0154 7.75615 14.0156 8.25098V16.7441C14.0156 17.2391 13.6233 17.627 13.124 17.627C12.6291 17.6269 12.2461 17.2391 12.2461 16.7441V8.25098C12.2463 7.75621 12.6293 7.36045 13.124 7.36035ZM19.2881 8.94922C19.7831 8.94922 20.1797 9.34913 20.1797 9.83984V15.1562C20.1795 15.6467 19.7829 16.0381 19.2881 16.0381C18.7932 16.038 18.4104 15.6467 18.4102 15.1562V9.83984C18.4102 9.3492 18.7931 8.94932 19.2881 8.94922ZM3.87402 9.80957C4.37752 9.80968 4.7695 10.2145 4.76953 10.7051V14.2861C4.76953 14.7811 4.37755 15.1727 3.87402 15.1729C3.38331 15.1729 3 14.7812 3 14.2861V10.7051C3.00003 10.2144 3.38333 9.80957 3.87402 9.80957Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgWaveform);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Waveform = Memo;
export { Waveform as default };
